<template>
  <div>
    <b-modal v-model="modalShow" ok-only centered class="text-center text-info">
      You have already created a shop with this email. You can create only one
      shop with an email. Please use another email to create another shop.
    </b-modal>
    <b-modal
      v-model="modalShow2"
      ok-only
      centered
      class="text-center text-info"
    >
      You have already created a page with this email. You can create either one
      page or one shop with an email. Please use another email to create a shop.
    </b-modal>
    <b-modal
      v-model="modalShow1"
      ok-only
      centered
      class="text-center text-info"
    >
      You have already signed in. Please sign out & sign up again to create
      another shop.
    </b-modal>
    <b-modal
      v-model="modalShow3"
      ok-only
      centered
      class="text-center text-info"
    >
      You have successfully registered. We will contact you soon.
    </b-modal>
    <div class="loading" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div v-if="fetch">
      <div class="">
        <nav class="navbar" style="background-color: rgba()">
          <router-link class="navbar-brand" to="/">
            <img src="../../../static/img/eshops-round.png" alt="shopin-logo" />
          </router-link>
          <div>
            <router-link to="/" class="text-info mr-1 m-link">Home</router-link>
            <!-- <router-link  :to="{name: 'startstore'}" class=" text-white m-link">Start Store</router-link> -->
          </div>
        </nav>
        <div style="background-color: rgba(0, 0, 0, 0); height: 100%" class="">
          <div class="col-sm-8 col-md-8 col-lg-6 m-auto pl-4 pb-4">
            <h3 class="m-auto text-center pb-4" style="color: #e94de9">
              Create Your Store
            </h3>
            <el-form
              class="pt-4"
              :model="formdata"
              :rules="rules"
              ref="formdata"
              label-width="200px"
              :label-position="labelPosition"
              size="medium"
              status-icon
              style="
                border: 1px solid #e2e2e2;
                border-radius: 5px;
                background-color: #fff;
                padding: 20px;
              "
            >
              <!-- <el-form-item label="Prefered Plan" prop="region">
    <el-select v-model="formdata.region" placeholder="Activity zone">
      <el-option label="Zone one" value="shanghai"></el-option>
      <el-option label="Zone two" value="beijing"></el-option>
    </el-select>
  </el-form-item> -->

              <!-- <el-form-item label="City/Town" prop="location">
       <el-row class="demo-autocomplete">
  <el-col :span="12">
    
  <el-autocomplete
      
      class="inline-input"
      v-model="formdata.location"
      :fetch-suggestions="querySearch"
      placeholder="Please Input"
      @select="handleSelect"
    ></el-autocomplete>
    </el-col>
       </el-row>
    </el-form-item> -->
              <el-form-item label="City/Town" prop="location">
                <el-cascader
                  clearable
                  placeholder="City"
                  size="medium"
                  @change="handleChange"
                  v-model="city"
                  :options="cities"
                  :show-all-levels="false"
                ></el-cascader>
              </el-form-item>

              <el-form-item label="Shop Category" prop="shopcat">
                <el-cascader
                  clearable
                  placeholder="Shop Category"
                  size="medium"
                  @change="handleChange2"
                  v-model="shopcat"
                  :options="shops"
                  :show-all-levels="false"
                ></el-cascader>
              </el-form-item>

              <!-- <el-form-item label="Shop Category" prop="shopcat">
     <el-select v-model="shopcat" placeholder="Shop Category">
    <el-option
      v-for="(shop, key) in shops"
      :key="key"
      :label="key"
      :value="key">
    </el-option>
  </el-select>
</el-form-item>

<el-form-item label="Shop Type" prop="shoptype" v-if="subshops.length != 0">
     <el-select v-model="formdata.shoptype" placeholder="Shop Type" :disabled="subshops.length == 0">
    <el-option
      v-for="(shop, key) in subshops"
      :key="shop"
      :label="shop"
      :value="shop">
    </el-option>
  </el-select>
</el-form-item> -->
              <el-form-item label="Shop Name" prop="name">
                <el-input
                  placeholder="Shop Name"
                  v-model="formdata.name"
                ></el-input>
              </el-form-item>

              <el-form-item label="Referee Code" prop="refCode">
                <el-input
                  placeholder="Referee Code"
                  v-model="formdata.refCode"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if='userDisplayName == "editor" || userDisplayName == "super admin"'
                label="API Key"
                prop="api"
                :rules="[
                  { required: true, message: 'API key is required' },
                ]"
              >
                <el-input
                  placeholder=""
                  v-model="formdata.api"
                  auto-complete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if='userDisplayName == "editor" || userDisplayName == "super admin"'
                label="Project ID"
                prop="pidNo"
                :rules="[
                  { required: true, message: 'Project ID is required' },
                ]"
              >
                <el-input
                  placeholder="Project ID"
                  v-model="formdata.pidNo"
                  auto-complete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Telephone"
                prop="telephone"
                :rules="[
                  { required: true, message: 'telephone no is required' },
                  { type: 'number', message: 'telephone no must be a number' },
                ]"
              >
                <el-input
                  placeholder="777666666"
                  v-model.number="formdata.telephone"
                  auto-complete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="System ID"
                prop="sysid"
                :rules="[
                  { required: true, message: 'System ID is required' },
                ]"
              >
                <el-input
                  placeholder="Please remember this to login to Dashboard"
                  v-model="formdata.sysid"
                  auto-complete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                prop="email"
                label="Email"
                :rules="[
                  {
                    required: true,
                    message: 'Please input email address',
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  placeholder="Email"
                  type="email"
                  v-model="formdata.email"
                  :disabled="disableEmail"
                ></el-input>
              </el-form-item>
              <el-form-item label="Password" prop="pass">
                <el-input
                  placeholder="Password (min 6 characters)"
                  type="password"
                  v-model="formdata.pass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="Confirm Password" prop="checkPass">
                <el-input
                  placeholder="Confirm Password"
                  type="password"
                  v-model="formdata.checkPass"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="checked"
                  style="color: #e94de9; font-weight: 800"
                  >I Agree</el-checkbox
                >
              </el-form-item>
              <el-form-item>
                <router-link :to="{ name: 'privacypolicy' }" class="text-info"
                  >Terms of Use and Privacy Policy</router-link
                >
              </el-form-item>
              <el-form-item class="pb-5" style="margin-bottom: 0px">
                <el-button
                  type="primary"
                  :disabled="checked == false"
                  @click="submitForm('formdata')"
                  >Create</el-button
                >
                <el-button type="danger" @click="resetForm('formdata')"
                  >Reset</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
//import dataUrl from '../../data/dataUrl'
import cities from "../../data/regcities";
import shops from "../../data/shops";
import Categories from "../../data/categories";
import { bus } from "../../main";
export default {
  name: "regshop",

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else {
        if (this.formdata.checkPass !== "") {
          this.$refs.formdata.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.formdata.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };

    return {
      cities: [],
      city: [],
      shops: [],
      catValues: {},
      plan: "",
      users: [],
      docid: "",
      dataUrl: "",
      disableEmail: false,
      modalShow: false,
      modalShow1: false,
      modalShow2: false,
      modalShow3: false,
      // subshops:[],
      shopcat: [],
      checked: true,
      loading: false,
      fetch: false,
      config: {},
      formdata: {
        location: "",
        district: "",
        categories: {},
        shopcat: "",
        shoptype: "",
        name: "",
        rank: "",
        email: "",
        api: "",
        sysid: "",
        pidNo: '',
        pass: "",
        checkPass: "",
        telephone: "",
        refCode: "",
        maxProducts: "",
        curProducts: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        links: [],
      },
      owner: "",
      isLoggedIn: false,
      currentUser: false,
      userDisplayName: '',
      labelPosition: "top",
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        name: [
          {
            required: true,
            message: "Please input shop name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 50,
            message: "Length should be 3 to 50",
            trigger: "blur",
          },
        ],

        location: [
          {
            required: true,
            message: "Please select location",
            trigger: "change",
          },
        ],
        shopcat: [
          {
            required: true,
            message: "Please pick a category",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "Please select at least one activity type",
            trigger: "change",
          },
        ],
        resource: [
          {
            required: true,
            message: "Please select activity resource",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "Please input activity form",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    // shopcat(){
    //   this.subshops = []
    //   this.formdata.shoptype = ''
    //   this.subshops = this.shops[this.shopcat]
    //   //console.log('subshops', this.subshops)
    // }
  },
  methods: {
    handleChange(value) {
      //console.log(value)
      this.formdata.district = value[0];
      this.formdata.location = value[1];
      //console.log('this.searchForm.location',this.formdata.location)
      //console.log('this.searchForm.district',this.formdata.district)
    },
    handleChange2(value) {
      //console.log(value)
      if (value.length == 0) {
        this.formdata.shopcat = "";
      } else if (value.length == 1) {
        this.formdata.shopcat = value[0];
        this.formdata.categories = Categories[value[0]];
        var catvalue = [];
        catvalue = Object.keys(this.formdata.categories);
        var newObj = {};
        for (var i = 0; i < catvalue.length; i++) {
          newObj[catvalue[i]] = 0;
        }
        this.catValues = newObj;
        //console.log('catValues',this.catValues)
        //console.log('category1',this.formdata.shopcat)
        //console.log('categories are',this.formdata.categories)
      } else if (value.length == 2) {
        if (
          value[0] == "Home Appliances" ||
          value[0] == "Home Decor" ||
          value[0] == "Essential Goods & Food"
        ) {
          this.formdata.shopcat = value[1];
          this.formdata.categories = Categories[value[1]];
          var catvalue = [];
          catvalue = Object.keys(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          // console.log('catValues',this.catValues)
          // console.log('category2',this.formdata.shopcat)
          //  console.log('categories are',this.formdata.categories)
        } else if (value[0] == "Vehicles" || value[0] == "Auto Parts") {
          this.formdata.shopcat = value[0];
          this.formdata.shoptype = value[1];
          this.formdata.categories = Categories[value[0]];
          var catvalue = [];
          catvalue = Object.keys(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          //console.log('catValues',this.catValues)
          //console.log('category2',this.formdata.shopcat)
          //console.log('categories are',this.formdata.categories)
        } else {
          this.formdata.shopcat = value[0];
          this.formdata.shoptype = value[1];
          this.formdata.categories = Categories[value[1]];
          var catvalue = [];
          catvalue = Object.keys(this.formdata.categories);
          var newObj = {};
          for (var i = 0; i < catvalue.length; i++) {
            newObj[catvalue[i]] = 0;
          }
          this.catValues = newObj;
          //console.log('catValues',this.catValues)
          //console.log('category',this.formdata.shopcat)
          //console.log('type',this.formdata.shoptype)
          //console.log('categories are',this.formdata.categories)
        }
      }
    },
    submitForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          this.fetch = false;
          this.loading = true;
          let displayName = "shop owner";
          let permissions = this.$store.state.permissionsList
          if (this.plan === 'Starter' || this.plan === 'Basic') {
            displayName = 'starterplan shop owner'
            permissions = this.$store.state.starterPlanPermissionsList
          }

          if (firebase.auth().currentUser) {
            if (
              firebase.auth().currentUser.displayName == "editor" ||
              firebase.auth().currentUser.displayName == "super admin"
            ) {
              // this.config.projectId = "eshopslkshop" + this.pidNo;
              this.config.projectId = this.formdata.pidNo //"eshopslk-pos-" + this.pidNo; // example -> eshopslk-pos-1
              //console.log('this.config', this.config['projectId'])
              this.config.authDomain = this.config.projectId + ".firebaseapp.com";
              this.config.databaseURL =
                "https://" + this.config.projectId + ".firebaseio.com";
              this.config.storageBucket = this.config.projectId + ".appspot.com";
              this.config.apiKey = this.formdata.api;

              // below if condition and firebase auth implementation for previous self shop registration

              // if (firebase.auth().currentUser.displayName == null) {
              // var user = firebase.auth().currentUser;
              // user
              //   .updateProfile({
              //     displayName: "shop owner",
              //   })
              //   .then(() => {
              //     // Update successful.
              //     //console.log(user)
              //   })
              //   .catch((error) => {
              //     alert(error);
              //     //console.log(error)
              //   });

              // db.collection("users")
              //   .doc(this.docid)
              //   .update({
              //     name: this.formdata.name,
              //     pswd: this.formdata.pass,
              //     role: "shop owner",
              //   })
              //   .then((docRef) => {
              //     //console.log(id)
              //   })
              //   .catch((error) => {
              //     // alert(error)
              //     //console.log(error)
              //   });

              // console.log("curentUser", firebase.auth().currentUser);

              let user;
              firebase
                .auth()
                .createUserWithEmailAndPassword(
                  this.formdata.email,
                  this.formdata.pass
                )
                .then((newUser) => {
                  // alert('Please Wait a Moment. Your Account is being Created.')
                  // console.log(
                  //   "curentUser after reg",
                  //   firebase.auth().currentUser
                  // );
                  user = newUser.user;
                  user
                    .updateProfile({
                      displayName,
                    })
                    .then(() => {
                      // Update successful.
                      //console.log(user)
                    })
                    .catch((error) => {
                      alert(error);
                    });

                  db.collection("users")
                    .doc(user.uid)
                    .set({
                      name: this.formdata.name,
                      email: this.formdata.email,
                      pswd: this.formdata.pass,
                      uid: user.uid,
                      role: displayName,
                      favshops: [],
                      favpages: [],
                      created: firebase.firestore.Timestamp.now(),
                    })
                    .then((docRef) => {
                      //var id = docRef.id
                      // //console.log(id)
                    })
                    .catch((error) => {
                      alert(error);
                    });

                  if (this.plan == "Starter") {
                    this.formdata.maxProducts = 25;
                    this.formdata.rank = 10;
                  } else if (this.plan == "Basic") {
                    this.formdata.maxProducts = 200;
                    this.formdata.rank = 8;
                  } else if (this.plan == "Premium") {
                    this.formdata.maxProducts = 2000;
                    this.formdata.rank = 6;
                  } else if (this.plan == "Enterprise") {
                    this.formdata.maxProducts = 5000;
                    this.formdata.rank = 4;
                  } else {
                    this.formdata.maxProducts = 0;
                    this.formdata.rank = 99999;
                  }
                  db.collection("shops")
                    .doc(user.uid)
                    .set({
                      name: this.formdata.name,
                      plan: this.plan,
                      district: this.formdata.district,
                      location: this.formdata.location,
                      categories: this.formdata.categories,
                      cat: this.formdata.shopcat,
                      shoptype: this.formdata.shoptype,
                      catValues: this.catValues,
                      maxProducts: this.formdata.maxProducts,
                      curProducts: 0,
                      curOffers: 0,
                      search: "yes",
                      visits: 0,
                      orders: 0,
                      created: firebase.firestore.Timestamp.now(),
                      rank: this.formdata.rank,
                      permission: "allowed",
                      owner: user.uid,
                      regemail: this.formdata.email,
                      regtel: this.formdata.telephone,
                      refCode: this.formdata.refCode,
                      config: this.config,
                      hasconfig: true,
                      details: {
                        stime: "",
                        etime: "",
                        tel1: "",
                        tel2: "",
                        address: "",
                        email: "",
                        lat: "",
                        lng: "",
                      },
                      cus: 0,
                      pay: 0,
                      users: 0,
                      invo: 0,
                      netPay: 0,
                      totalRemain: 0,
                      setting: {
                        printSize: "POS Printer 80 mm Paper",
                        printPopup: true,
                        discountMode: "Percentage",
                        lowStockAlertQuantity: 1,
                        loyalityPoints: 0,
                        referralPoints: 0,
                        header: "",
                        footer: "",
                      },
                      noDB: false
                    })
                    .then((docRef) => {
                      this.pidNo += 1;
                      this.cusNo += 1;
                      db.collection("aaa")
                        .doc("pid")
                        .update({
                          pidNo: this.pidNo,
                          cusNo: this.cusNo,
                        })
                        .then(() => {
                          var secondary = firebase.initializeApp(
                            this.config,
                            user.uid
                          );
                          this.$store.state.secondaryDatabase =
                            secondary.firestore();
                          // this.$store.state.secondaryApp = this.$route.params.storename
                          this.$store.state.secondaryDatabase.settings({
                            timestampsInSnapshots: true,
                          });
                          this.$store.state.secondaryDatabase
                            .enablePersistence({
                              synchronizeTabs: true,
                            })
                            .then(() => {
                              //console.log("Woohoo! Multi-Tab Persistence!");
                            });

                            firebase
                            .auth(secondary)
                            .createUserWithEmailAndPassword(
                              this.formdata.email,
                              user.uid
                            )
                            .then((usr) => {})
                            .catch( err => alert(err))
                          this.$store.state.secondaryDatabase
                            .collection("shops")
                            .doc(user.uid)
                            .set({
                              name: this.formdata.name,
                              plan: this.plan,
                              district: this.formdata.district,
                              location: this.formdata.location,
                              categories: this.formdata.categories,
                              cat: this.formdata.shopcat,
                              shoptype: this.formdata.shoptype,
                              catValues: this.catValues,
                              maxProducts: this.formdata.maxProducts,
                              curProducts: 0,
                              curOffers: 0,
                              search: "yes",
                              visits: 0,
                              orders: 0,
                              created: firebase.firestore.Timestamp.now(),
                              rank: this.formdata.rank,
                              permission: "allowed",
                              owner: user.uid,
                              regemail: this.formdata.email,
                              regtel: this.formdata.telephone,
                              refCode: this.formdata.refCode,
                              config: this.config,
                              hasconfig: true,
                              details: {
                                stime: "",
                                etime: "",
                                tel1: "",
                                tel2: "",
                                address: "",
                                email: "",
                                lat: "",
                                lng: "",
                              },
                              cus: 0,
                              pay: 0,
                              users: 1, // adding belowa as admin
                              invo: 0,
                              netPay: 0,
                              totalRemain: 0,
                              setting: {
                                printSize: "POS Printer 80 mm Paper",
                                printPopup: true,
                                discountMode: "Percentage",
                                lowStockAlertQuantity: 1,
                                loyalityPoints: 0,
                                referralPoints: 0,
                                header: "",
                                footer: "",
                              },
                            })
                            .then((id) => {
                              //console.log('secondaryDB shop id', id)
                              const sysuser = {
                                  name: "Admin",
                                  email: this.formdata.email,
                                  city: this.formdata.location,
                                  regdate: firebase.firestore.Timestamp.now(),
                                  //uid: firebase.auth().currentUser.uid,
                                  telephone: this.formdata.telephone,
                                  sysid: this.formdata.sysid || "1234",
                                  role: "Admin",
                                  store: [],
                                  note: "",
                                  permissions,
                                };
                              this.$store.state.secondaryDatabase
                                .collection("sysusers")
                                .add(sysuser)
                                .then((docRef) => {
                                  this.$store.state.systemUser = sysuser 
                                  delete this.$store.state.systemUser.sysid
                                })
                                .catch((error) => alert(error));
                              firebase
                                .auth()
                                .currentUser.sendEmailVerification()
                                .then(() => {
                                  window.location.reload()
                                  //this.$router.push("/admin");
                                })
                                .catch((error) => alert(error));
                            })
                            .catch((error) => alert(error));
                        })
                        .catch((error) => alert(error));
                      // var id = docRef.id
                      // //console.log(id)
                      //this.modalShow3 = true
                      //console.log(docRef.id)
                      //  db.collection('shops').doc(docRef.id)
                      // .collection('notify').add(
                      // {
                      //   notice: {
                      //     title:'Congratulations!',
                      //     msg:'Your eshop has been successfully created.'
                      //   }
                      // })
                      // .then(docRef => {
                      //this.$router.push("/admin");
                      //   //console.log('msg added')
                      // }).catch(error =>{
                      //     alert(error)
                      //     //console.log(error)
                      // })
                      // firebase.auth().currentUser.photoURL = docRef.id;
                      // //console.log(firebase.auth().currentUser.photoURL)
                    })
                    .catch((error) => {
                      alert(error);
                      //console.log(error)
                    });
                })
                .catch((error) => {
                  alert(error);
                });
            } else if (
              firebase.auth().currentUser.displayName == "shop owner" ||
              firebase.auth().currentUser.displayName ==
                "starterplan shop owner"
            ) {
              if (this.formdata.email == firebase.auth().currentUser.email) {
                this.fetch = true;
                this.loading = false;
                this.modalShow = true;
              } else {
                this.fetch = true;
                this.loading = false;
                this.modalShow1 = true;
              }
            } else if (
              firebase.auth().currentUser.displayName == "page owner"
            ) {
              if (this.formdata.email == firebase.auth().currentUser.email) {
                this.fetch = true;
                this.loading = false;
                this.modalShow2 = true;
              } else {
                this.fetch = true;
                this.loading = false;
                this.modalShow1 = true;
              }
            }
          } else {
            firebase
              .auth()
              .createUserWithEmailAndPassword(
                this.formdata.email,
                this.formdata.pass
              )
              .then((user) => {
                // alert('Please Wait a Moment. Your Account is being Created.')
                var user = firebase.auth().currentUser;
                user
                  .updateProfile({
                    displayName,
                  })
                  .then(() => {
                    // Update successful.
                    //console.log(user)
                  })
                  .catch((error) => {
                    alert(error);
                  });

                // user.sendEmailVerification().then(() => {
                //this.$router.push("/verifyemail");
                //console.log(user, "Email sent");// Email sent.
                db.collection("users")
                  .doc(firebase.auth().currentUser.uid)
                  .set({
                    name: this.formdata.name,
                    email: this.formdata.email,
                    pswd: this.formdata.pass,
                    uid: user.uid,
                    role: displayName,
                    favshops: [],
                    favpages: [],
                    created: firebase.firestore.Timestamp.now(),
                  })
                  .then((docRef) => {
                    //var id = docRef.id
                    // //console.log(id)
                  })
                  .catch((error) => {
                    //console.log(error)
                  });

                if (this.plan == "Starter") {
                  this.formdata.maxProducts = 25;
                  this.formdata.rank = 10;
                } else if (this.plan == "Basic") {
                  this.formdata.maxProducts = 200;
                  this.formdata.rank = 8;
                } else if (this.plan == "Premium") {
                  this.formdata.maxProducts = 2000;
                  this.formdata.rank = 6;
                } else if (this.plan == "Enterprise") {
                  this.formdata.maxProducts = 10000;
                  this.formdata.rank = 4;
                } else {
                  this.formdata.maxProducts = 0;
                  this.formdata.rank = 99999;
                }
                db.collection("shops")
                  .doc(firebase.auth().currentUser.uid)
                  .set({
                    name: this.formdata.name,
                    plan: this.plan,
                    district: this.formdata.district,
                    location: this.formdata.location,
                    categories: this.formdata.categories,
                    cat: this.formdata.shopcat,
                    shoptype: this.formdata.shoptype,
                    catValues: this.catValues,
                    maxProducts: this.formdata.maxProducts,
                    curProducts: 0,
                    curOffers: 0,
                    search: "yes",
                    visits: 0,
                    orders: 0,
                    created: firebase.firestore.Timestamp.now(),
                    rank: this.formdata.rank,
                    permission: "allowed",
                    owner: user.uid,
                    regemail: this.formdata.email,
                    regtel: this.formdata.telephone,
                    refCode: this.formdata.refCode,
                    config: this.config,
                    hasconfig: true,
                    details: {
                      stime: "",
                      etime: "",
                      tel1: "",
                      tel2: "",
                      address: "",
                      email: "",
                      lat: "",
                      lng: "",
                    },
                    cus: 0,
                    pay: 0,
                    users: 0,
                    invo: 0,
                    netPay: 0,
                    totalRemain: 0,
                    setting: {
                      printSize: "POS Printer 80 mm Paper",
                      printPopup: true,
                      discountMode: "Percentage",
                      lowStockAlertQuantity: 1,
                      loyalityPoints: 0,
                      referralPoints: 0,
                      header: "",
                      footer: "",
                    },
                    noDB: true
                  })
                  .then((docRef) => {
                    this.pidNo += 1;
                    this.cusNo += 1;
                    db.collection("aaa")
                      .doc("pid")
                      .update({
                        // pidNo: this.pidNo, // as not having own DB
                        cusNo: this.cusNo,
                      })
                      .then(() => {
                        // if having own DB - will not happen when user creating account as he cant create indexes
                          // so commented below block

                        // if (noDB) { 
                        // var secondary = firebase.initializeApp(
                        //   this.config,
                        //   firebase.auth().currentUser.uid
                        // );
                        // this.$store.state.secondaryDatabase =
                        //   secondary.firestore();
                        // // this.$store.state.secondaryApp = this.$route.params.storename
                        // this.$store.state.secondaryDatabase.settings({
                        //   timestampsInSnapshots: true,
                        // });
                        // this.$store.state.secondaryDatabase
                        //   .enablePersistence({
                        //     synchronizeTabs: true,
                        //   })
                        //   .then(() => {
                        //     //console.log("Woohoo! Multi-Tab Persistence!");
                        //   });
                        // this.$store.state.secondaryDatabase
                        //   .collection("shops")
                        //   .doc(firebase.auth().currentUser.uid)
                        //   .set({
                        //     name: this.formdata.name,
                        //     plan: this.plan,
                        //     district: this.formdata.district,
                        //     location: this.formdata.location,
                        //     categories: this.formdata.categories,
                        //     cat: this.formdata.shopcat,
                        //     shoptype: this.formdata.shoptype,
                        //     catValues: this.catValues,
                        //     maxProducts: this.formdata.maxProducts,
                        //     curProducts: 0,
                        //     curOffers: 0,
                        //     search: "yes",
                        //     visits: 0,
                        //     orders: 0,
                        //     created: firebase.firestore.Timestamp.now(),
                        //     rank: this.formdata.rank,
                        //     permission: "allowed",
                        //     owner: user.uid,
                        //     regemail: this.formdata.email,
                        //     regtel: this.formdata.telephone,
                        //     refCode: this.formdata.refCode,
                        //     config: this.config,
                        //     hasconfig: true,
                        //     details: {
                        //       stime: "",
                        //       etime: "",
                        //       tel1: "",
                        //       tel2: "",
                        //       address: "",
                        //       email: "",
                        //       lat: "",
                        //       lng: "",
                        //     },
                        //     cus: 0,
                        //     pay: 0,
                        //     users: 0,
                        //     invo: 0,
                        //     netPay: 0,
                        //     totalRemain: 0,
                        //     setting: {
                        //       printSize: "POS Printer 80 mm Paper",
                        //       printPopup: true,
                        //       discountMode: "Percentage",
                        //       lowStockAlertQuantity: 1,
                        //       loyalityPoints: 0,
                        //       referralPoints: 0,
                        //       header: "",
                        //       footer: "",
                        //     },
                        //   })
                        //   .then((id) => {
                        //     //console.log('secondaryDB shop id', id)
                           
                        //      this.$store.state.secondaryDatabase
                        //         .collection("sysusers")
                        //         .add({
                        //           name: "Admin",
                        //           email: this.formdata.email,
                        //           city: this.formdata.location,
                        //           regdate: firebase.firestore.Timestamp.now(),
                        //           //uid: firebase.auth().currentUser.uid,
                        //           telephone: this.formdata.telephone,
                        //           sysid: "1234",
                        //           role: "Admin",
                        //           store: [],
                        //           note: "",
                        //           permissions: this.$store.state.permissionsList,
                        //         })
                        //         .then((docRef) => {})
                        //         .catch((error) => alert(error));
                        //       firebase
                        //         .auth()
                        //         .currentUser.sendEmailVerification()
                        //         .then(() => {
                        //           this.$store.state.systemUser.isLogedIn = true;
                        //           this.$store.state.systemUser.role = "Admin";
                        //           this.$router.push("/admin");
                        //         })
                        //         .catch((error) => alert(error));
                        //   })
                        //   .catch((error) => {
                        //     //console.log(error)
                        //   });
                        // } else {
                          this.$store.state.secondaryDatabase = db;
                          
                            this.$store.state.secondaryDatabase
                            .collection("stores")
                            .add({
                              name: this.formdata.name,
                              email: this.formdata.email,
                              city: this.formdata.location,
                              address: '',
                              telephone: this.formdata.telephone,
                              invo: 0,
                              netPay: 0,
                              totalRemain: 0,
                              totalProfit: 0,
                              POTotal: 0,
                              POs: 0,
                              PORemain: 0,
                              totalExp: 0,
                              shopOwner: firebase.auth().currentUser.uid,
                              setting: {
                                printSize: "POS Printer 80 mm Paper",
                                printPopup: true,
                                // discountMode: "",
                                taxMode: "Percentage",
                                // lowStockAlertQuantity: 1,
                                loyalityPoints: 0,
                                referralPoints: 0,
                                // header: "",
                                footer: "",
                                printOnly: true,
                              },
                            })
                            .then((docRef) => {
                              const sysuser = {
                                name: "Admin",
                                email: this.formdata.email,
                                city: this.formdata.location,
                                regdate: firebase.firestore.Timestamp.now(),
                                shopOwner: firebase.auth().currentUser.uid,
                                telephone: this.formdata.telephone,
                                sysid: this.formdata.sysid || "1234",
                                role: "Admin",
                                store: [docRef.id],
                                note: "",
                                permissions,
                              };
                              this.$store.state.secondaryDatabase
                                .collection("sysusers")
                                .add(sysuser)
                                .then((docRef) => { 
                                  this.$store.state.systemUser = sysuser 
                                  delete this.$store.state.systemUser.sysid
                                })
                                .catch((error) => alert(error));
                            })
                            .catch((error) => alert(error));
                            
                              firebase
                                .auth()
                                .currentUser.sendEmailVerification()
                                .then(() => {
                                  window.location.reload(true)
                                  //this.$router.push("/admin");
                                })
                                .catch((error) => alert(error));
                       // }
                      })
                      .catch((error) => {
                        //console.log(error)
                      });
                    //var id = docRef.id
                    //console.log(id)
                    //this.modalShow3 = true
                    //console.log(docRef.id)
                    //  db.collection('shops').doc(id)
                    // .collection('notify').add(
                    // {
                    //   notice: {
                    //     title:'Congratulations!',
                    //     msg:'Your eshop has been successfully created.'
                    //   }
                    // })
                    // .then(docRef => {
                    //   //console.log('msg added')
                    // }).catch(error =>{
                    //     alert(error)
                    // })
                    // firebase.auth().currentUser.photoURL = docRef.id;
                    // //console.log(firebase.auth().currentUser.photoURL)
                  })
                  .catch((error) => {
                    //console.log(error)
                  });

                // }).catch(error =>{
                //       console.log(error)
                //     })
              })
              .catch((error) => {
                //console.log(error)
              });
          }
        } else {
          alert("error submit!!!");
          return false;
        }
      });
      //var user = firebase.auth().currentUser;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadAll() {
      return [
        { value: "Kandy", link: "https://github.com/vuejs/vue" },
        { value: "Embilipitiya", link: "https://github.com/ElemeFE/element" },
        { value: "cooking", link: "https://github.com/ElemeFE/cooking" },
        { value: "mint-ui", link: "https://github.com/ElemeFE/mint-ui" },
        { value: "vuex", link: "https://github.com/vuejs/vuex" },
        { value: "vue-router", link: "https://github.com/vuejs/vue-router" },
        { value: "babel", link: "https://github.com/babel/babel" },
        { value: "vue", link: "https://github.com/vuejs/vue" },
        { value: "element", link: "https://github.com/ElemeFE/element" },
        { value: "cooking", link: "https://github.com/ElemeFE/cooking" },
        { value: "mint-ui", link: "https://github.com/ElemeFE/mint-ui" },
        { value: "vuex", link: "https://github.com/vuejs/vuex" },
        { value: "vue-router", link: "https://github.com/vuejs/vue-router" },
      ];
    },
    handleSelect(item) {
      //console.log(item);
    },
  },
  beforeRouteEnter(to, from, next) {
    //console.log('path', to.fullPath)
    if (
      to.fullPath == "/registration/Basic" ||
      to.fullPath == "/registration/Premium" ||
      to.fullPath == "/registration/Enterprise"
    ) {
      next();
    } else {
      setTimeout(() => {
        next((vm) => {
          return vm.$router.push(from.fullPath);
        });
      }, 100);
    }
  },
  mounted() {
    this.links = this.loadAll();
    // this.loading = false
    // this.fetch = true
  },
  created() {
    this.loading = true;
    this.fetch = false;
    //this.dataUrl = dataUrl
    //console.log('screen',screen.width)
    if (screen.width > 575) {
      this.labelPosition = "right";
    } else {
      this.labelPosition = "top";
    }
    this.cities = cities;
    this.shops = shops;
    this.plan = this.$route.params.plan || "Premium";
    if (firebase.auth().currentUser) {
      this.userDisplayName = firebase.auth().currentUser.displayName
      if (firebase.auth().currentUser.displayName == null) {
        this.formdata.email = firebase.auth().currentUser.email;
        this.disableEmail = true;
        db.collection("users")
          .where("uid", "==", firebase.auth().currentUser.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                docid: doc.id,
              };
              this.users.push(data);
              this.docid = this.users[0].docid;
              //console.log('this.docid',this.docid)
            });
          });
      }
      // this.isLoggedIn = true;
      // this.currentUser = firebase.auth().currentUser.email;
    }
    this.loading = true;
    this.fetch = false;
    db.collection("aaa")
      .doc("pid")
      .get()
      .then((doc) => {
        this.pidNo = doc.data().pidNo;
        this.cusNo = doc.data().cusNo;
        this.loading = false;
        this.fetch = true;
      })
      .catch((error) => alert(error));
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/loading.css");
</style>


// WEBPACK FOOTER //
// src/components/user/RegShop.vue